export default function batchRequest<T, R>(fn: (values: T[]) => Promise<R>, batchSize: number) {
  if (batchSize <= 0) {
    throw new Error('batchSize must be a positive integer');
  }

  return async (values: T[]): Promise<R> => {
    let start = 0;
    const promises: Promise<R>[] = [];

    const end = values.length;
    while (start < end) {
      const batch = values.slice(start, start + batchSize);
      promises.push(fn(batch));
      start += batchSize;
    }

    try {
      const responses = await Promise.all(promises);
      return responses.flat() as R;
    } catch (e) {
      console.error('Error in batch processing:', e);
      throw e;
    }
  };
}
